import { useState, useEffect, memo } from 'react'
import { Wrapper } from 'src/components/common/Wrapper'
import useLoading from 'src/components/layouts/hooks/useLoading'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Slider from 'react-slick'
import { DRAW_TYPE } from 'src/models/GachaInfo'
import FadeTransition from 'src/components/common/transitions/FadeTransition'
import { MainLayout } from 'src/components/layouts/MainLayout'
import StandardPageWrapper from 'src/components/common/StandardPageWrapper'
import Loading from 'src/components/layouts/Loading'
import CapsuleTab from 'src/pages/main/capsule/CapsuleTab'
import { Modal } from 'src/components/common/Modal'
import CapsuleDrawModal from 'src/pages/main/capsule/CapsuleDrawModal'
import Item, { ITEM_TYPE } from 'src/models/Item'
import TipsModal from 'src/components/common/TipsModal'
import Improgress from './components/Improgress'

import blueHeaderBackground from 'src/assets/img/menu/background/blue_header_background.png'
import returnIcon from 'src/assets/img/menu/icon/return_icon.png'

import 'src/pages/main/capsule/scroller.css'

const GACHA_TYPE_API_MAP = {
  avatar: 'cloth',
  item: 'item',
  still: 'still',
  mixer: 'mixer'
}

const ThumbnailScroller = ({ gachas, onChangeTab }) => {
  const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    arrows: false,
    pauseOnHover: false,
    cssEase: 'linear',
    autoplaySpeed: 5000
  }

  return (
    <section className="z-10 thumbnail-scroller">
      <Slider {...settings}>
        {gachas.map((tab, index) => (
          <div key={tab.id} className="slider-item" onClick={() => onChangeTab(index)}>
            <img src={tab.banner_image} alt={tab.name} />
          </div>
        ))}
      </Slider>
    </section>
  )
}

const GachaHeader = memo(({ gachas, onChangeTab }) => {
  return (
    <div
      className="flex justify-end relative my-3 aspect-[390/147] cursor-pointer"
      style={{ backgroundImage: `url(${blueHeaderBackground})`, backgroundSize: 'cover' }}
    >
      <div className="flex flex-col w-full items-center relative">
        <div className="flex justify-between w-full z-10 pl-2 pr-4 items-center absolute top-[8%] xs:top-[15%] sm:top-[15%]">
          <h1 className="text-[#CFE5FF] font-extrabold text-[3.8125rem] font-Outfit">GACHA</h1>
          <h2 className="bg-cornflower-blue xs:text-[1.375rem] font-bold font-Inter text-white rounded-[3rem] px-4">
            ガチャ
          </h2>
        </div>
        <div className="absolute bottom-0 z-10 w-[351px]">
          {gachas?.length > 3 ? (
            <ThumbnailScroller gachas={gachas} onChangeTab={onChangeTab} />
          ) : (
            <div className="justify-center flex gap-2">
              {gachas?.map((tab, index) => (
                <img
                  className="w-[107px]"
                  src={tab.banner_image}
                  key={tab.id}
                  alt={tab.name}
                  onClick={() => onChangeTab(index)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
      <img src={returnIcon} className="absolute h-[100%] top-1" />
    </div>
  )
})

GachaHeader.displayName = 'GachaHeader'

const CapsuleToyPage = ({
  isLoading,
  itemsTicket,
  redCount,
  blueCount,
  gachas,
  setItemsUpdate,
  items
}) => {
  const [slideIndex, setSlideIndex] = useState(0)
  const [showDrawModal, setShowDrawModal] = useState(false)
  const [drawType, setDrawType] = useState(DRAW_TYPE.Free)
  const [allGachas, setAllGachas] = useState([])
  const [isVideoPlaying, setIsVideoPlaying] = useState(true)
  const [ticket, setTicket] = useState(false)
  const [idItem, setIdItem] = useState(0)
  const [rollFree, setRollFree] = useState([])
  const [countTimeRollCurrent, setcountTimeRoll] = useState({})
  const [gachaDetail, setGachaDetail] = useState({})
  const [regularTicket, setRegularTicket] = useState([])
  const [SSRTicket, setSSRTicket] = useState([])
  const [typeGacha, setTypeGacha] = useState('cloth')
  const [maxHeight, setMaxHeight] = useState('max-h-80')

  useEffect(() => {
    if (!gachas || !Array.isArray(gachas)) return

    const activeGachas = gachas.filter((el) => el.status !== 'disable')
    setAllGachas(activeGachas)

    const firstGacha = activeGachas[0]
    setIdItem(firstGacha?.id || 0)
    setTypeGacha(GACHA_TYPE_API_MAP[firstGacha?.gacha_type])
  }, [gachas])

  useEffect(() => {
    const filterTicketItems = itemsTicket?.filter(
      (el) => el.type === ITEM_TYPE.Special && el.itemKind === 'gacha_ticket'
    )
    const filterSSRItems = itemsTicket?.filter(
      (el) => el.type === ITEM_TYPE.Special && el.itemKind === 'ssr_ticket'
    )
    setRegularTicket(filterTicketItems)
    setSSRTicket(filterSSRItems)
  }, [itemsTicket])

  const handleSetIdItem = (id) => {
    setIdItem(id)
    const selected = allGachas.find((el) => el.id === id)
    if (selected) setTypeGacha(GACHA_TYPE_API_MAP[selected.gacha_type] || selected.gacha_type)
  }

  const openDrawModal = (type) => {
    setDrawType(type)
    setShowDrawModal(true)
  }

  const closeDrawModal = () => {
    setShowDrawModal(false)
  }

  const { showLoading, progress } = useLoading([isLoading])
  if (showLoading) {
    return (
      <Wrapper>
        <Loading progress={progress} />
      </Wrapper>
    )
  }

  return (
    <>
      <MainLayout active="gacha" classNameHeader="">
        <StandardPageWrapper
          className={clsx('h-full flex flex-col', isLoading && 'justify-center p-4')}
        >
          <GachaHeader gachas={allGachas} onChangeTab={setSlideIndex} />

          {allGachas && allGachas.length > 0 ? (
            <CapsuleTab
              slideIndex={slideIndex}
              setSlideIndex={setSlideIndex}
              gachas={allGachas}
              isShown={true}
              showDrawModal={openDrawModal}
              setTicket={setTicket}
              setIdItem={handleSetIdItem}
              rollFree={rollFree}
              setGachaDetail={setGachaDetail}
              gachaDetail={gachaDetail}
              countTimeRollCurrent={countTimeRollCurrent}
              setcountTimeRoll={setcountTimeRoll}
            />
          ) : (
            <FadeTransition
              show={true}
              className="flex justify-center h-[100vh] flex-col p-4 pointer-events-none"
            >
              <Improgress />
            </FadeTransition>
          )}

          <Modal
            maxHeight={maxHeight}
            focusOutside={false}
            open={showDrawModal}
            onClose={isVideoPlaying ? () => false : closeDrawModal}
            isVideoPlaying={isVideoPlaying}
            className="sm:w-[360px] w-11/12 absolute top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 text-left transform transition-all sm:max-w-lg font-hiragino flex items-center justify-center"
          >
            <CapsuleDrawModal
              setMaxHeight={setMaxHeight}
              drawType={drawType}
              handleClose={closeDrawModal}
              redCount={redCount}
              blueCount={blueCount}
              ticketCount={regularTicket[0]?.amount || 0}
              ssrCount={SSRTicket[0]?.amount || 0}
              isVideoPlaying={isVideoPlaying}
              setIsVideoPlaying={setIsVideoPlaying}
              ticket={ticket}
              idItem={idItem}
              setRollFree={setRollFree}
              setGachaDetail={setGachaDetail}
              setItemsTicketUpdate={setItemsUpdate}
              itemsUpdate={itemsTicket}
              itemsTicketRoll={items}
              setcountTimeRoll={setcountTimeRoll}
              typeGacha={typeGacha}
            />
          </Modal>
          <TipsModal type="capsule" />
        </StandardPageWrapper>
      </MainLayout>
    </>
  )
}

ThumbnailScroller.propTypes = {
  gachas: PropTypes.array,
  onChangeTab: PropTypes.func
}

GachaHeader.propTypes = {
  gachas: PropTypes.array,
  onChangeTab: PropTypes.func
}

CapsuleToyPage.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.instanceOf(Item)).isRequired,
  redCount: PropTypes.number.isRequired,
  blueCount: PropTypes.number.isRequired,
  gachas: PropTypes.array,
  itemsTicket: PropTypes.array,
  setItemsUpdate: PropTypes.func
}

export default CapsuleToyPage
